import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {Service} from "../../../../../classes/service";

@Component({
    selector: 'kan-service-list',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanServiceList {
    @Input() public services: Service[];
    @Output() refresh: EventEmitter<any> = new EventEmitter();

    constructor() {
    }

    ngOnInit(): void {
    }

    public emitRefresh(): void {
        this.refresh.emit();
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/service/list/component.ts